import router from "../router";

export default {
  methods: {
    kick: function() {
      localStorage.clear();
      sessionStorage.clear();
      router.push("/login");
    },
  },
};
